import { render, staticRenderFns } from "./FormAttentionText.vue?vue&type=template&id=b9ee98a2&scoped=true&"
import script from "./FormAttentionText.vue?vue&type=script&lang=js&"
export * from "./FormAttentionText.vue?vue&type=script&lang=js&"
import style0 from "./FormAttentionText.vue?vue&type=style&index=0&id=b9ee98a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ee98a2",
  null
  
)

export default component.exports